import { Component, ReactNode } from 'react';
import FAppError from '../FAppError';
import appErrorBoundaryLang from './langs/appErrorBoundaryLang';
import { withTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import FAppLog from '../../log/FAppLog';

interface Props {
	t?: TFunction;
	children: ReactNode;
}
interface State {
	error: Error | null;
}

// FIXME: deprecated class method, turn it to function component
class AppErrorBoundary extends Component<Props, State> {
	public state: State = {
		error: null,
	};

	public static getDerivedStateFromError(e: Error): State {
		return { error: e };
	}

	public componentDidCatch(e: Error) {
		this.setState({ error: e });
	}

	public render() {
		const { t } = this.props;
		if (this.state.error) {
			return (
				<FAppLog e={this.state.error}>
					<FAppError
						variant="container"
						title={t?.(appErrorBoundaryLang.public_title.tag)}
						content={t?.(appErrorBoundaryLang.public_description.tag)}
					/>
				</FAppLog>
			);
		}

		return this.props.children;
	}
}

export default withTranslation()(AppErrorBoundary);
